import ArticleCard, {
	ArticleCardProps as _ArticleCardProps,
} from './ArticleCard';

export { ArticleCard };
export type ArticleCardProps = _ArticleCardProps;
